import React, { useState, useEffect } from 'react';
// Use relative paths for imports
import DailySuccessJournal from './DailySuccessJournal';
import WeeklySuccessJournal from './WeeklySuccessJournal';
import PerformanceJournal from './PerformanceJournal';
import Mixpanel from '../utils/mixpanel';
import GuideModal from './GuideModal';
import StandardWidthContainer from './StandardWidthContainer';
import './DesktopComponentStyles.css';

const Journal = () => {
  const [activeJournal, setActiveJournal] = useState('daily');
  
  useEffect(() => {
    // Use the enhanced feature tracking instead of generic page view
    Mixpanel.trackFeatureUsed('Journal', 'Opened');
  }, []);
  
  const handleJournalChange = (journal) => {
    setActiveJournal(journal);
    
    // Use the enhanced feature action tracking
    Mixpanel.trackFeatureAction('Journal', 'Type Selected', {
      type: journal,
      timestamp: new Date().toISOString()
    });
  };

  const journalTabs = [
    { id: 'daily', label: 'Daily' },
    { id: 'weekly', label: 'Weekly' },
    { id: 'performance', label: 'Performance' }
  ];

  return (
    <>
      <GuideModal guideKey="Journal" />
      <div className="container px-4 pt-4" style={{ width: '1024px !important', maxWidth: '1024px !important', margin: '0 auto !important', boxSizing: 'border-box !important' }}>
          {/* Journal Type Tabs with grid layout */}
          <div className="grid grid-cols-3 gap-2 mb-8">
            {journalTabs.map((tab) => (
              <div 
                key={tab.id}
                onClick={() => handleJournalChange(tab.id)}
                className={`p-4 border rounded-lg cursor-pointer transition-colors text-center ${
                  activeJournal === tab.id 
                    ? 'border-primary bg-primary/20 font-semibold' 
                    : 'border-base-300 hover:border-primary/50 hover:bg-primary/5'
                }`}
              >
                <h3 className="text-lg font-medium">{tab.label}</h3>
              </div>
            ))}
          </div>

          {/* Journal Content */}
          <div className="bg-base-100 rounded-box shadow-sm p-4 desktop-standard-card" style={{ width: '100% !important', maxWidth: 'none !important' }}>
            {activeJournal === 'daily' && <DailySuccessJournal />}
            {activeJournal === 'weekly' && <WeeklySuccessJournal />}
            {activeJournal === 'performance' && <PerformanceJournal />}
          </div>
      </div>
    </>
  );
};

export default Journal;